import VisibilityIcon from '@mui/icons-material/Visibility';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { type ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { selectImpersonation, useCurrentUser, useStopImpersonationMutation } from '../lib/auth';

export function ImpersonationBanner(): ReactElement | null {
    const { t } = useTranslation();
    const impersonation = selectImpersonation(useCurrentUser());
    const stopImpersonation = useStopImpersonationMutation();

    if (!impersonation) {
        return null;
    }

    const handleStop = (): void => {
        stopImpersonation.mutate();
    };

    return (
        <Box
            role="alert"
            sx={{
                bgcolor: 'warning.main',
                color: 'warning.contrastText',
                px: 3,
                py: 1,
                position: 'sticky',
                top: 0,
                zIndex: (theme) => theme.zIndex.appBar + 1,
            }}>
            <Stack
                direction="row"
                spacing={2}
                alignItems="center"
                justifyContent="space-between"
                sx={{ maxWidth: 1200, mx: 'auto' }}>
                <Stack direction="row" spacing={1} alignItems="center">
                    <VisibilityIcon fontSize="small" />
                    <Typography variant="body2" sx={{ fontWeight: 600 }}>
                        {t('IMPERSONATION.BANNER_MESSAGE', { email: impersonation.impersonatorEmail })}
                    </Typography>
                </Stack>
                <Button
                    size="small"
                    color="inherit"
                    variant="outlined"
                    onClick={handleStop}
                    disabled={stopImpersonation.isPending}>
                    {t('IMPERSONATION.STOP')}
                </Button>
            </Stack>
        </Box>
    );
}
